module.exports = __webpack_public_path__ + "img/App-Modernization-Services_1.28f52c80.webp";